import {
  DayOffsRequest,
  DayOffsResponse,
  RejectDayOffRequest,
  TakeToWorkInfo,
  TDayOffResponse,
  TDayOffSingleResponse,
} from 'shared/types/dayoff.types';
import { edpApiV1 } from './index';

export const dayoffsApi = edpApiV1.injectEndpoints({
  endpoints: build => ({
    dayoffs: build.query<DayOffsResponse, DayOffsRequest>({
      query: payload => ({ url: '/v1/admin/hr/time-off/requests', method: 'GET', params: payload }),
      providesTags: ['dayoff'],
    }),
    singleDayoff: build.query<TDayOffSingleResponse, { id: number | string; allAvailableOrganizations: boolean }>({
      query: ({ id, ...params }) => ({ url: `/v1/admin/hr/time-off/requests/${id}`, method: 'GET', params }),
      providesTags: ['dayoff'],
    }),
    approveDayoff: build.mutation<string, number>({
      query: id => ({ url: `/v1/admin/hr/time-off/requests/${id}/approve`, method: 'POST' }),
      invalidatesTags: ['dayoff'],
    }),
    rejectDayoff: build.mutation<string, RejectDayOffRequest>({
      query: ({ requestId, ...body }) => ({
        url: `/v1/admin/hr/time-off/requests/${requestId}/reject`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['dayoff'],
    }),
    takeToWorkDayOff: build.mutation<unknown, TakeToWorkInfo>({
      query: ({ requestId }) => ({
        url: `/v1/admin/hr/time-off/requests/${requestId}/take-to-work`,
        method: 'POST',
      }),
      invalidatesTags: ['dayoff'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useApproveDayoffMutation,
  useDayoffsQuery,
  useLazyDayoffsQuery,
  useLazySingleDayoffQuery,
  useRejectDayoffMutation,
  useSingleDayoffQuery,
  useTakeToWorkDayOffMutation,
} = dayoffsApi;
